import React, { useState } from 'react';

const OpponentGrid = ({ opponents, onAddOpponent, onSelectOpponent }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredOpponents = opponents.filter(opponent => {
    const fullName = `${opponent.firstName} ${opponent.lastName}`.toLowerCase();
    return fullName.includes(searchTerm.toLowerCase());
  });

  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-4">
        <input
          type="text"
          placeholder="Search by name..."
          className="p-2 border border-gray-300 rounded-md w-1/2"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button
          onClick={onAddOpponent}
          className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
        >
          Add Opponent
        </button>
      </div>

      {/* Desktop and Tablet View */}
      <div className="overflow-x-auto hidden sm:block">
        <table className="min-w-full bg-white">
          <thead>
            <tr>
              <th className="py-2 px-4 border-b text-left">First Name</th>
              <th className="py-2 px-4 border-b text-left">Last Name</th>
              <th className="py-2 px-4 border-b text-left">UTR</th>
              <th className="py-2 px-4 border-b text-left">WTN</th>
              <th className="py-2 px-4 border-b text-left">Club</th>
              <th className="py-2 px-4 border-b text-left">Last Played</th>
            </tr>
          </thead>
          <tbody>
            {filteredOpponents.map(opponent => (
              <tr key={opponent.id} className="hover:bg-gray-100 cursor-pointer" onClick={() => onSelectOpponent(opponent)}>
                <td className="py-2 px-4 border-b">{opponent.firstName}</td>
                <td className="py-2 px-4 border-b">{opponent.lastName}</td>
                <td className="py-2 px-4 border-b">{opponent.utr || 'N/A'}</td>
                <td className="py-2 px-4 border-b">{opponent.wtn || 'N/A'}</td>
                <td className="py-2 px-4 border-b">{opponent.club || 'N/A'}</td>
                <td className="py-2 px-4 border-b">{opponent.last_played ? new Date(opponent.last_played).toLocaleDateString() : 'Never'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile View */}
      <div className="sm:hidden">
        {filteredOpponents.length === 0 ? (
          <p className="text-center text-gray-600">No opponents found.</p>
        ) : (
          <div className="grid grid-cols-1 gap-4">
            {filteredOpponents.map(opponent => (
              <div key={opponent.id} className="bg-gray-50 p-4 rounded-lg shadow-md border border-gray-200 cursor-pointer" onClick={() => onSelectOpponent(opponent)}>
                <p className="font-semibold text-lg mb-2">{opponent.firstName} {opponent.lastName}</p>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div>
                    <p className="text-gray-500">UTR:</p>
                    <p className="font-medium">{opponent.utr || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-gray-500">WTN:</p>
                    <p className="font-medium">{opponent.wtn || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-gray-500">Club:</p>
                    <p className="font-medium">{opponent.club || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-gray-500">Last Played:</p>
                    <p className="font-medium">{opponent.last_played ? new Date(opponent.last_played).toLocaleDateString() : 'Never'}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OpponentGrid;


